import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=58bbc05f&scoped=true&"
import script from "./EditProject.vue?vue&type=script&lang=ts&"
export * from "./EditProject.vue?vue&type=script&lang=ts&"
import style0 from "./EditProject.vue?vue&type=style&index=0&id=58bbc05f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bbc05f",
  null
  
)

export default component.exports